import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { NavItemNames } from '@employer/app/services/navigation.service'
import { FileNotFoundComponent } from '../_404/404.component'
import { PublicComponent } from './public.component'
import { PublicPrivacyComponent } from './views/privacy/privacy.component'
import { PublicTermsComponent } from './views/terms/terms.component'

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    // canActivate: [ AuthGuard ],
    children: [
      { path: 'profile-share', loadChildren: () => import('../profile-share/profile-share.module').then(m => m.ProfileShareModule) },
      {
        path: 'privacy',
        component: PublicPrivacyComponent,
      },
      {
        path: 'terms',
        component: PublicTermsComponent,
      },
      {
        path: '404',
        component: FileNotFoundComponent,
        data: { title: NavItemNames.FileNotFound },
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
